import React, { useEffect, useState } from 'react';
import './Article.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useRouteMatch } from 'react-router';

// Import components
import PageWrapper from 'components/Layout/PageWrapper/PageWrapper';
import indexPost from 'actions/post/index';
import indexPage from 'actions/page/index';

import Title from './components/Title/Title';
import Text from './components/Text/Text';
import QuoteBlock from './components/QouteBlock/QuoteBlock';
import HighlightBlock from './components/HighlightBlock/HighlightBlock';
import ImageSingle from './components/ImageSingle/ImageSingle';
import ImageDouble from './components/ImageDouble/ImageDouble';
import ButtonRow from './components/ButtonRow/ButtonRow';
import Line from './components/Line/Line';
import ShareYourKnowlegeForm from './ShareYourKnowlegeForm/ShareYourKnowlegeForm';

export default function Article() {
  const { id, url } = useParams() as {
    id: string;
    url: string;
  };

  const [articleId, setArticleId] = useState<string>();
  const [type, setType] = useState<string>('article');
  const dispatch = useDispatch();
  const route = useRouteMatch();

  // Add stuff to store
  useEffect(() => {
    if (route.path === '/artikel/:id') {
      dispatch(indexPost());
      setArticleId(id);
      setType('article');
    } else {
      dispatch(indexPage());
      setType('page');
    }
  }, []);

  const pages = useSelector((state) =>
    state.page.entities.allIds.map((id) => state.page.entities.byId[id])
  );
  console.log(pages);
  const article = useSelector((state) => state.post.entities.byId[articleId]);

  const articleData =
    type == 'article' ? article : pages.find((page) => page.url === url);
  const articleContent = articleData?.content;

  // console.log(articleData, 'article data');
  // console.log(articleContent, 'article content');

  return (
    <PageWrapper article background={articleData?.background}>
      <div
        styleName={`article ${url.includes('deel-jouw-kennis') ? 'blue' : ''}${
          url.includes('over-youtoo') ? 'red' : ''
        }${url.includes('partners') ? 'yellow' : ''}`}
      >
        {articleContent?.map((item, i) => {
          console.log(item.layout);
          if (item.layout === 'title') {
            return <Title item={item} key={i} />;
          }
          if (item.layout === 'text') {
            return <Text item={item} key={i} />;
          }
          if (item.layout === 'quote_block') {
            return <QuoteBlock item={item} key={i} />;
          }
          if (item.layout === 'highlight_block') {
            return <HighlightBlock item={item} key={i} />;
          }
          if (item.layout === 'image_single') {
            return <ImageSingle item={item} key={i} />;
          }
          if (item.layout === 'image_double') {
            return <ImageDouble item={item} key={i} />;
          }
          if (item.layout === 'button_row') {
            return <ButtonRow item={item} key={i} />;
          }
          if (item.layout === 'line') {
            return <Line key={i} />;
          }
        })}
        {url.includes('deel-jouw-kennis') && <ShareYourKnowlegeForm />}
      </div>
    </PageWrapper>
  );
}
